import Button from "@ingka/button";

const BottomButtons = ({
  onOk,
  onEdit,
  assetSelection,
  uploadDone,
}: {
  onOk: () => void;
  onEdit: () => void;
  assetSelection: string[];
  uploadDone: boolean;
}) => (
  <div className="col-span-2 col-start-3 flex flex-row content-end justify-end">
    <Button
      size="medium"
      text="Mark selected asset(s) as OK"
      type="primary"
      className="ml-space150"
      onClick={onOk}
      disabled={assetSelection.length === 0 || uploadDone}
    />
    <Button
      size="medium"
      text="Edit selected asset(s)"
      type="primary"
      className="ml-space150"
      disabled={assetSelection.length === 0 || uploadDone}
      onClick={onEdit}
    />
  </div>
);

export default BottomButtons;
